import {
  GET_DASHBOARD_REVENUE_SUCCESS,
  GET_DASHBOARD_REVENUE_FAIL,
  GET_DASHBOARD_OCCUPANCY_SUCCESS,
  GET_DASHBOARD_OCCUPANCY_FAIL,
  GET_LOTS_SOLD_SUCCESS,
  GET_LOTS_SOLD_FAIL,
  GET_LOTS_SOLD,
} from "./actionTypes"

const INIT_STATE = {
  revenueData: null,
  occupancyData: null,
  message: "",
  error: {},
  lotsSold: [],
  isLoadingLotsSold: false,
}

const Dashboard = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DASHBOARD_REVENUE_SUCCESS:
      return {
        ...state,
        revenueData: action.payload?.data,
      }

    case GET_DASHBOARD_REVENUE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_DASHBOARD_OCCUPANCY_SUCCESS:
      return {
        ...state,
        occupancyData: action.payload?.data,
      }

    case GET_DASHBOARD_OCCUPANCY_FAIL:
      return {
        ...state,
        error: action.payload,
        occupancyData: null,
      }
    case GET_LOTS_SOLD:
      return {
        ...state,
        isLoadingLotsSold: true,
      }
    case GET_LOTS_SOLD_SUCCESS:
      return {
        ...state,
        lotsSold: action.payload?.data || [],
        isLoadingLotsSold: false,
      }
    case GET_LOTS_SOLD_FAIL:
      return {
        ...state,
        error: action.payload,
        lotsSold: [],
        isLoadingLotsSold: false,
      }
    default:
      return state
  }
}

export default Dashboard
